import { Container, Row, Col } from "react-bootstrap";
import { Outlet } from "react-router-dom";

const ContainerLayout = () => (
    <Container className="py-4">
        <Row>
            <Col lg={9} className="mx-auto">
                <Outlet />
            </Col>
        </Row>
    </Container>
);

export default ContainerLayout;
